module.exports = __webpack_public_path__ + "ba.no1.1c056360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ba.no1.jpg
// module id = puqr
// module chunks = 0